import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { Form } from "react-bootstrap"
import Select from "react-select"
import { cloneDeep } from "lodash"
import { byId } from "../../../common/jsonapi-filters";
import { AppState } from "../../../reducers";
import ChargeContext from "../../../contexts/ChargeContext"

const Insurance = () => {
	const insurances = useSelector((state: AppState) => state.insurance.data)
	const [charge, setCharge] = useContext(ChargeContext)

	const setInsurance = (insurance: any) => {
		const next = cloneDeep(charge)
		next.relationships.insurance.data.id = insurance.id
		setCharge(next)
	}

	return <Form.Group>
		<Form.Label>Insurance</Form.Label>
		{
			<Select
				value={insurances.find(byId(charge.relationships.insurance.data.id))}

				onChange={setInsurance}

				options={insurances.filter((insurance: any) => insurance.attributes.active)}

				getOptionLabel={(option: any) => option.attributes.name}
				getOptionValue={(option: any) => option.id}
			/>
		}
	</Form.Group>
}

export default Insurance